<template>
  <div class="justify-center gallery">
    <img
      @click="showGallery()"
      class="pa-4 pa-sm-8 pa-md-16 mx-auto cursor-pointer gallery-img"
      :src="active + '?resize=1&w=' + (smOnly ? 960 : 600)"
      width="100%"
    />

    <CarouselWidget
      class="products-carousel-widget"
      :items="items"
      :items-to-show="itemsToShow"
      nav
      nav-inside
    >
      <template #item="{ item, index }">
        <img
          @click="
            active = item;
            i = index;
          "
          class="pa-3 pa-md-3 cursor-pointer gallery-thumb"
          :class="{ 'gallery-thumb-active': active == item }"
          :src="item + '?resize=1&w=100'"
          width="100%"
        />
      </template>
    </CarouselWidget>
  </div>
</template>

<script>
import CarouselWidget from "../../components/widgets/CarouselWidget/Index.vue";

const _carouselSettings = {
  itemsToShow: {
    xs: 3,
    sm: 4,
    md: 5,
    lg: 5,
    xl: 5,
  },
};

export default {
  props: {
    main: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    active: 0,
    i: 0,
    ..._carouselSettings,
  }),
  computed: {
    smOnly() {
      return this.$vuetify.breakpoint.smOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    showGallery() {
      window.showGalleryWidget(this.items, this.i);
    },
  },
  mounted() {
    this.active = this.main;
  },
  components: {
    CarouselWidget,
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  display: grid;
  gap: 8px;
  grid-template-columns: 100%;

  &-img,
  &-thumb {
    aspect-ratio: 270 / 170;
    border: 1px solid #ccc;
    border-radius: 2px;
    -o-object-fit: contain;
    object-fit: contain;
  }

  &-thumbs {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;

    @media screen and (max-width: 960px) {
      grid-template-columns: repeat(auto-fit, 100px);
    }
  }
}

.gallery-thumb-active {
  border: 1px solid var(--v-primary-base);
}

.products-carousel-widget::v-deep {
  > .position-relative {
    padding-left: 40px;
    padding-right: 40px;
  }

  .carousel-widget-nav--inside {
    left: 0;
    right: 0;
  }
}
</style>
